// Angular import
import { Component, OnInit, inject, input } from '@angular/core';
import { Location } from '@angular/common';

// project import
import { NavigationItem } from 'src/app/@theme/types/navigation';
import { SharedModule } from 'src/app/demo/shared/shared.module';
import { MenuCollapseComponent } from '../menu-collapse/menu-collapse.component';
import { MenuItemHorizontalComponent } from '../menu-item/menu-item.component';

@Component({
  selector: 'app-menu-group-horizontal',
  imports: [SharedModule, MenuCollapseComponent, MenuItemHorizontalComponent],
  templateUrl: './menu-group.component.html',
  styleUrls: ['./menu-group.component.scss']
})
export class MenuGroupHorizontalComponent implements OnInit {
  private location = inject(Location);

  // public props
  // All Version in Group Name
  readonly item = input<NavigationItem>();
  current_url!: string;

  // Life cycle events
  ngOnInit() {
    this.current_url = this.location.path();
    // eslint-disable-next-line
    //@ts-ignore
    const baseHref = this.location['_baseHref'] || '';
    this.current_url = baseHref + this.current_url;

    // Use a more reliable way to find and update the active group
    setTimeout(() => {
      const links = document.querySelectorAll('a.nav-link') as NodeListOf<HTMLAnchorElement>;
      links.forEach((link: HTMLAnchorElement) => {
        if (link.getAttribute('href') === this.current_url) {
          this.activateParentMenu(link);
        }
      });
    }, 0);
  }

  // Activate parent elements based on matched URL
  activateParentMenu(element: HTMLAnchorElement) {
    let parent = element.parentElement;
    while (parent && parent.classList) {
      if (parent.classList.contains('coded-hasmenu')) {
        parent.classList.add('coded-trigger');
        parent.classList.add('active');
      }
      parent = parent.parentElement;
    }
  }
}
